import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "tw-w-full tw-flex tw-flex-col tw-justify-start tw-items-center" }
const _hoisted_2 = { class: "tw-w-full tw-pt-2 tw-px-2 tw-justify-self-start tw-mb-2" }
const _hoisted_3 = { class: "tw-w-full tw-h-16 p-shadow-5 tw-bg-gray-50 tw-rounded" }
const _hoisted_4 = { class: "tw-w-full tw-flex tw-items-center tw-h-full tw-p-2 md:tw-px-8" }
const _hoisted_5 = { class: "tw-ml-auto tw-flex tw-items-center" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h3", { class: "" }, [
  /*#__PURE__*/_createElementVNode("b", null, "CAMBIAR CONTRASEÑA")
], -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "tw-w-full" }, null, -1)
const _hoisted_9 = { class: "p-fluid tw-space-y-4" }
const _hoisted_10 = { class: "p-field" }
const _hoisted_11 = { class: "p-field" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("p", { class: "p-mt-2" }, "Sugerencias:", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("ul", {
  class: "p-pl-2 p-ml-2 p-mt-0",
  style: {"line-height":"1.5"}
}, [
  /*#__PURE__*/_createElementVNode("li", null, "Minimo 8 caracteres"),
  /*#__PURE__*/_createElementVNode("li", null, "Una letra en mayusculas"),
  /*#__PURE__*/_createElementVNode("li", null, "al menos un numero")
], -1)
const _hoisted_14 = { class: "p-field" }
const _hoisted_15 = { class: "tw-w-full tw-text-sm tw-text-red-500" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Toast = _resolveComponent("Toast")!
  const _component_MenuMobile = _resolveComponent("MenuMobile")!
  const _component_Sidebar = _resolveComponent("Sidebar")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Avatar = _resolveComponent("Avatar")!
  const _component_Menu = _resolveComponent("Menu")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_Password = _resolveComponent("Password")!
  const _component_Divider = _resolveComponent("Divider")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _component_ConfirmDialog = _resolveComponent("ConfirmDialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Toast, { position: "bottom-right" }),
    _createElementVNode("div", {
      style: _normalizeStyle(`background-image:url(${_ctx.BackgroundImage});`),
      class: "home tw-bg-gray-200 tw-flex tw-h-screen"
    }, [
      _createVNode(_component_Sidebar, {
        visible: _ctx.slideVisible,
        "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.slideVisible) = $event)),
        position: "left",
        class: "tw-w-full! home-sidebar md:tw-w-5/12! xl:tw-w-1/2! tw-text-center!"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_MenuMobile, {
            isMenuBar: true,
            isSlide: true,
            onClicked: _cache[0] || (_cache[0] = ($event: any) => (_ctx.handleMenuClick(false)))
          })
        ]),
        _: 1
      }, 8, ["visible"]),
      _createVNode(_component_MenuMobile, { isMenuBar: true }),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_Button, {
                class: "lg:tw-hidden p-button-rounded p-button-outlined p-button-sm",
                icon: "pi pi-bars",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.handleMenuClick(!_ctx.slideVisible)))
              }),
              _createElementVNode("div", _hoisted_5, [
                (_ctx.pacienteLogueado)
                  ? (_openBlock(), _createBlock(_component_Dropdown, {
                      key: 0,
                      modelValue: _ctx.pacienteLogueado,
                      onChange: _ctx.handleChange,
                      options: [..._ctx.pacientesRelacionados,_ctx.pacienteLogueado],
                      optionLabel: "nombre",
                      class: "tw-mr-2 tw-max-w-20ch! sm:tw-max-w-none!",
                      style: {"color":"var(--text-color)"}
                    }, null, 8, ["modelValue", "onChange", "options"]))
                  : _createCommentVNode("", true),
                _createVNode(_component_Avatar, {
                  icon: "pi pi-user",
                  class: "p-shadow-1 tw-cursor-pointer",
                  size: "large",
                  shape: "circle",
                  "aria-haspopup": "true",
                  "aria-controls": "overlay_menu",
                  onClick: _ctx.toggle
                }, null, 8, ["onClick"]),
                _createVNode(_component_Menu, {
                  id: "overlay_menu",
                  ref: "menu",
                  model: _ctx.dropMenuItems,
                  popup: true
                }, null, 8, ["model"])
              ])
            ])
          ])
        ]),
        _createVNode(_component_router_view)
      ])
    ], 4),
    _createVNode(_component_Dialog, {
      class: "tw-w-96",
      visible: _ctx.editarPass,
      modal: true
    }, {
      header: _withCtx(() => [
        _hoisted_6,
        _hoisted_7
      ]),
      title: _withCtx(() => [
        _hoisted_8
      ]),
      footer: _withCtx(() => [
        _createVNode(_component_Button, {
          label: "Guardar",
          onClick: _ctx.handleClick
        }, null, 8, ["onClick"]),
        _createVNode(_component_Button, {
          label: "Cancelar",
          class: "p-button-link",
          onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.handleEditarPassClick(false)))
        })
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_Password, {
              loading: _ctx.isLoad,
              placeholder: "Contraseña Actual",
              toggleMask: "",
              modelValue: _ctx.oldpassword,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.oldpassword) = $event)),
              feedback: false
            }, null, 8, ["loading", "modelValue"])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createVNode(_component_Password, {
              placeholder: "Nueva Contraseña",
              toggleMask: "",
              modelValue: _ctx.password,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.password) = $event))
            }, {
              footer: _withCtx(() => [
                _createVNode(_component_Divider),
                _hoisted_12,
                _hoisted_13
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createVNode(_component_Password, {
              loading: _ctx.isLoad,
              placeholder: "Repita la Contraseña",
              toggleMask: "",
              modelValue: _ctx.passwordRepeat,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.passwordRepeat) = $event)),
              feedback: false
            }, null, 8, ["loading", "modelValue"])
          ]),
          _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.error), 1)
        ])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_ConfirmDialog)
  ], 64))
}